var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"shots"},_vm._l((_vm.shots),function(shot,shotId){return _c('li',{key:shotId,style:({
      width: (shot.end - shot.start) / _vm.videoLength * 100 + '%'
    }),attrs:{"title":("Shot " + (shotId + 1))}},[_c('router-link',{attrs:{"to":{ name: 'shot', params: { videoId: _vm.videoId, shotId: shotId }}}},[_c('div',{staticClass:"shot-position",style:({
        width: _vm.percentageInShot(shot.start, shot.end, _vm.currentTime) * 100 + '%'
      })})])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }